import { openDatabase, saveSnapshotDatabase } from "../Utils/db";

import { getDevices } from "../Utils/mediaUser";

import { ITeamDB } from "../interfaces/Team";

import { v4 as uuidv4 } from "uuid";

class Team {
  async getTeam(): Promise<ITeamDB> {
    const db = await openDatabase();

    const team = await db.team.toArray();

    return team[team.length - 1];
  }

  async setTeam(team: ITeamDB) {
    const db = await openDatabase();

    await db.team.put(team);

    await saveSnapshotDatabase();
  }

  async getDefaultTeam() {
    // Primar los labels/deviceIds: enumerateDevices() los oculta hasta que se

    // concede un permiso de media REAL. Sin este getUserMedia previo, en un

    // arranque limpio los micrófonos vienen sin label/id y no se puede elegir

    // uno → el team quedaba con mics:[] ("No microphones connected"). En Electron

    // el permiso se auto-concede; si el usuario lo deniega seguimos sin mic (no

    // rompemos el boot).

    let primingStream: MediaStream | null = null;
    try {
      primingStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
    } catch (err) {
      console.warn(
        "[Team] getUserMedia(audio) para primar dispositivos falló:",
        err,
      );
    }

    // Enumerar MIENTRAS el stream de primado sigue activo: en shells de Electron
    // sin setPermissionCheckHandler, enumerateDevices() solo expone labels/ids
    // mientras hay un permiso de media en curso. Cortamos el stream DESPUÉS.
    const devices = await getDevices();

    primingStream?.getTracks().forEach((track) => track.stop());

    const defaultTeam: ITeamDB = {
      mics: [],

      cams: [],

      id: 0,
    };

    // Elegir el micrófono default de forma robusta (NO por la subcadena "default"

    // del label, que viene vacía sin permiso y en Windows en español no dice

    // "default"): primero el deviceId "default" (pseudo-dispositivo del SO), si no

    // el que tenga "default" en el label, si no el primer audioinput usable.

    const audioInputs = devices.filter(
      (device) => device.kind === "audioinput" && device.deviceId,
    );

    const defaultMic =
      audioInputs.find((device) => device.deviceId === "default") ??
      audioInputs.find((device) =>
        device.label.toLowerCase().includes("default"),
      ) ??
      audioInputs.find((device) => device.deviceId !== "communications") ??
      audioInputs[0];

    if (defaultMic) {
      defaultTeam.mics.push({
        id: uuidv4(),

        name: defaultMic.deviceId,

        deviceInfo: {
          deviceId: defaultMic.deviceId,

          groupId: defaultMic.groupId,

          kind: defaultMic.kind,

          label: defaultMic.label,
        },

        capabilities: {},
      });
    }

    for (const device of devices) {
      if (device.kind === "videoinput") {
        defaultTeam.cams.push({
          id: uuidv4(),

          name: device.deviceId,

          deviceInfo: {
            deviceId: device.deviceId,

            groupId: device.groupId,

            kind: device.kind,

            label: device.label,
          },

          capabilities: {},
        });
      }
    }

    return defaultTeam;
  }
}

export default Team;
